export const analyticsEvents = {
  pricingFaqOpen: 'pricing_faq_open',
  freeTrialButtonClick: 'free_trial_button_click',
} as const;

export type AnalyticsEventName =
  (typeof analyticsEvents)[keyof typeof analyticsEvents];

export type AnalyticsEventProps = Record<
  string,
  string | number | boolean | null | undefined
>;
